// extracted by mini-css-extract-plugin
export var container = "advertising-section-module--container--jgwB9";
export var grid = "advertising-section-module--grid--sIR3c";
export var gridItemImageWrapper = "advertising-section-module--grid-item-image-wrapper--4OdwM";
export var gridItemImage = "advertising-section-module--grid-item-image--pYPIi";
export var gridItemText = "advertising-section-module--grid-item-text--Az6zl";
export var gridItem = "advertising-section-module--grid-item--wncii";